<template><div class="task-description-editor"><div ref="editor"></div><small>{{ length }} / 20 000 символов</small></div></template>
<script>
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
import DOMPurify from 'dompurify'
export default {
  props: { modelValue: { type: String, default: '' }, disabled: Boolean, label: { type: String, default: 'Описание задачи' } },
  emits: ['update:modelValue', 'files'],
  data: () => ({ length: 0 }),
  mounted() {
    this.editor = new Quill(this.$refs.editor, {
      theme: 'snow', placeholder: 'Опишите задачу и ожидаемый результат…',
      formats: ['header', 'bold', 'italic', 'underline', 'strike', 'list', 'blockquote', 'code-block', 'link'],
      modules: { toolbar: [[{ header: [2, 3, false] }], ['bold', 'italic', 'underline', 'strike'], [{ list: 'ordered' }, { list: 'bullet' }], ['blockquote', 'code-block', 'link'], ['clean']] }
    })
    this.editor.root.setAttribute('aria-label', this.label)
    this.editor.root.addEventListener('paste', this.pasteFiles, true)
    this.setContent(this.modelValue)
    this.editor.enable(!this.disabled)
    this.editor.on('text-change', this.changed)
    this.$el.querySelectorAll('.ql-toolbar button').forEach(button => { button.type = 'button' })
  },
  beforeUnmount() { this.editor.off('text-change', this.changed); this.editor.root.removeEventListener('paste', this.pasteFiles, true) },
  watch: {
    modelValue(value) { if (this.editor && value !== this.lastValue) this.setContent(value) },
    disabled(value) { if (this.editor) this.editor.enable(!value) }
  },
  methods: {
    setContent(value) { this.editor.clipboard.dangerouslyPasteHTML(DOMPurify.sanitize(value || ''), 'silent'); this.lastValue = value; this.length = value.length },
    changed() { const value = this.editor.getText().trim() ? this.editor.getSemanticHTML() : ''; this.lastValue = value; this.length = value.length; this.$emit('update:modelValue', value) },
    pasteFiles(event) { if (!this.disabled && event.clipboardData.files.length) { event.preventDefault(); event.stopImmediatePropagation(); this.$emit('files', Array.from(event.clipboardData.files)) } }
  }
}
</script>
<style>
.task-description-editor { min-width: 0; background: white; }
.task-description-editor .ql-toolbar { border-radius: 8px 8px 0 0; background: #f5f7fa; }
.task-description-editor .ql-container { font: inherit; border-radius: 0 0 8px 8px; }
.task-description-editor .ql-editor { min-height: 260px; max-height: 550px; line-height: 1.65; }
.task-description-editor small { display: block; color: #64748b; margin-top: 6px; }
</style>
